(module.exports = require('./core')).use(
  require('./mods/config')
)